<template>
  <div>
    <div class="topBtn">
      <Button type="primary" @click="addShareData" class="btn">设置共享者</Button>
    </div>
    <div class="permissions-con data-table">
      <div class="table-view" v-if="managerList.length > 0">
        <div class="table-title">
          <div class="blo"></div>
          <span>内部员工</span>
        </div>
        <vxe-table
            align="center"
            stripe
            show-overflow
            keep-source
            ref="xTable"
            highlight-hover-row
            height="433"
            :data="managerList"
            :auto-resize="true"
        >

          <vxe-table-column field="index" title="序号">
            <template slot-scope="{ $rowIndex }">
              <span>{{ $rowIndex + 1 }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="name" title="名称"></vxe-table-column>
        </vxe-table>
      </div>

      <div class="table-view" v-if="salesmanList.length > 0">
        <div class="table-title">
          <div class="blo"></div>
          <span>业务员</span>
        </div>
        <vxe-table
            align="center"
            stripe
            show-overflow
            keep-source
            ref="xTable"
            highlight-hover-row
            height="433"
            :data="salesmanList"
            :auto-resize="true"
        >

          <vxe-table-column field="index" title="序号">
            <template slot-scope="{ $rowIndex }">
              <span>{{ $rowIndex + 1 }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="name" title="名称"></vxe-table-column>
        </vxe-table>
      </div>
      <div class="table-view" v-if="departmentList.length > 0">
        <div class="table-title">
          <div class="blo"></div>
          <span>部门</span>
        </div>
        <vxe-table
            align="center"
            stripe
            show-overflow
            keep-source
            ref="xTable"
            highlight-hover-row
            height="433"
            :data="departmentList"
            :auto-resize="true"
        >

          <vxe-table-column field="index" title="序号">
            <template slot-scope="{ $rowIndex }">
              <span>{{ $rowIndex + 1 }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="name" title="名称"></vxe-table-column>
        </vxe-table>
      </div>
      <div class="table-view" v-if="groupList.length > 0">
        <div class="table-title">
          <div class="blo"></div>
          <span>角色</span>
        </div>
        <vxe-table
            align="center"
            stripe
            show-overflow
            keep-source
            ref="xTable"
            highlight-hover-row
            height="433"
            :data="groupList"
            :auto-resize="true"
        >

          <vxe-table-column field="index" title="序号">
            <template slot-scope="{ $rowIndex }">
              <span>{{ $rowIndex + 1 }}</span>
            </template>
          </vxe-table-column>
          <vxe-table-column field="name" title="名称"></vxe-table-column>
        </vxe-table>
      </div>
      <div
          v-if="managerList.length === 0 &&salesmanList.length === 0 &&departmentList.length === 0 &&groupList.length === 0"
          style="padding: 100px 0; text-align: center;width: 100%;">
        暂无数据
      </div>
    </div>
<!--    <div class="add-btn-box">-->
<!--      <Button status="primary" @click="submitShareData">确定</Button>-->
<!--    </div>-->
    <vxe-modal
        v-model="isShowAddShareData"
        title="添加数据共享"
        width="600"
        height="455"
        resize
    >
      <Tabs v-model="tabsVal">
        <TabPane label="内部员工" name="name1">
          <vxe-table
              class="table-style"
              align="center"
              :data="managerListData"
              border="none"
              height="300"
              stripe
              ref="managerListTable"
              auto-resize
              @checkbox-all="managerSelectAllEvent"
              @checkbox-change="managerSelectChangeEvent"
          >
            <vxe-table-column type="checkbox" width="60"></vxe-table-column>
            <vxe-table-column field="name" title="员工姓名"></vxe-table-column>
          </vxe-table>
        </TabPane>
        <TabPane label="业务员" name="name2">
          <vxe-table
              class="table-style"
              align="center"
              :data="salesmanListData"
              border="none"
              height="300"
              ref="salesmanListTable"
              stripe
              auto-resize
              @checkbox-all="salesmanSelectAllEvent"
              @checkbox-change="salesmanSelectChangeEvent"
          >
            <vxe-table-column type="checkbox" width="60"></vxe-table-column>
            <vxe-table-column field="name" title="业务员"></vxe-table-column>
          </vxe-table>
        </TabPane>
        <TabPane label="部门" name="name3">
          <vxe-table
              class="table-style"
              align="center"
              :data="departmentListData"
              border="none"
              height="300"
              ref="departmentListTable"
              stripe
              auto-resize
          >
            <vxe-table-column type="checkbox" width="60"></vxe-table-column>
            <vxe-table-column field="name" title="部门"></vxe-table-column>
          </vxe-table>
        </TabPane>
        <TabPane label="角色" name="name4">
          <vxe-table
              class="table-style"
              align="center"
              :data="groupListData"
              border="none"
              height="300"
              ref="groupListTable"
              stripe
              auto-resize
          >
            <vxe-table-column type="checkbox" width="60"></vxe-table-column>
            <vxe-table-column field="name" title="角色"></vxe-table-column>
          </vxe-table>
        </TabPane>
        <vxe-input
            v-if="tabsVal === 'name1' || tabsVal === 'name2'"
            v-model="name"
            type="search"
            placeholder="姓名"
            @keyup.enter.native="searchDate"
            @search-click="searchDate"
            slot="extra"
        ></vxe-input>
      </Tabs>
      <div class="add-btn-box">
        <Button @click="closeShareData">取消</Button>
        <Button status="primary" @click="submitShareData">确定</Button>
      </div>
    </vxe-modal>
  </div>
</template>
<script>

  import getAuthOrization from "@/mixin/getAuthOrization";
  import $api from "@/apiProvider";

  export default {
    mixins: [getAuthOrization],
    props: ['userId'],
    data() {
      return {
        tabsVal: 'name1',
        name: null,
        managerList: [], // 内部员工
        salesmanList: [], // 业务员
        departmentList: [], // 部门
        groupList: [], // 角色
        managerListData: [],
        salesmanListData: [],
        departmentListData: [],
        groupListData: [],
        checkManagerList: [],
        checkSalesmanList: [],
        checkDepartmentList: [],
        checkGroupList: [],
        isShowAddShareData: false,
        managerRecords: [],
        salesmanRecords: [],
      }
    },
    methods: {
      closeShareData() {
        this.isShowAddShareData = false;
        this.managerRecords = [];
        this.salesmanRecords = [];
      },
      changeShareData() {
        this.managerList = [...this.managerRecords];
        this.salesmanList = [...this.salesmanRecords];
        let departmentListRecords = this.$refs.departmentListTable.getCheckboxRecords();
        this.departmentList = [...departmentListRecords];
        let groupListRecords = this.$refs.groupListTable.getCheckboxRecords();
        this.groupList = [...groupListRecords];
        this.checkManagerList = [];
        this.managerRecords.forEach((v) => {
          this.checkManagerList.push(v.name);
          this.checkManagerList = [...new Set(this.checkManagerList)];
        });
        this.checkSalesmanList = [];
        this.salesmanRecords.forEach((v) => {
          this.checkSalesmanList.push(v.name);
          this.checkSalesmanList = [...new Set(this.checkSalesmanList)];
        });
        this.checkDepartmentList = [];
        departmentListRecords.forEach((v) => {
          this.checkDepartmentList.push(v.name);
          this.checkDepartmentList = [...new Set(this.checkDepartmentList)];
        });
        this.checkGroupList = [];
        groupListRecords.forEach((v) => {
          this.checkGroupList.push(v.name);
          this.checkGroupList = [...new Set(this.checkGroupList)];
        });

        this.closeShareData();
      },
      init(id) {
        // 分配权限
        this.role = [];
        this.company = [];
        this.checkManagerList = [];
        this.checkSalesmanList = [];
        this.checkDepartmentList = [];
        this.checkGroupList = [];
        this.ManagerListRecords = [];
        this.salesmanListRecords = [];
        this.departmentListRecords = [];
        this.groupListRecords = [];
        this.isShowPermissions = true;
        this.curId = id;
        this.getShareList(id);
      },
      async getShareList(id) {
        this.managerList = [];
        this.salesmanList = []; // 业务员
        this.departmentList = []; // 部门
        this.groupList = []; // 角色

        let url = `getSharing/${id}`;
        let res = await $api.baseUserSign.get(url);
        if (res.status === 1) {
          if (res.data.managerList && res.data.managerList.length > 0) {
            this.managerList = res.data.managerList;
            this.checkManagerList = this.managerList.map((v) => v.name);
          }
          if (res.data.salesmanList && res.data.salesmanList.length > 0) {
            this.salesmanList = res.data.salesmanList;
            this.checkSalesmanList = this.salesmanList.map((v) => v.name);
          }
          if (res.data.departmentList && res.data.departmentList.length > 0) {
            this.departmentList = res.data.departmentList;
            this.checkDepartmentList = this.departmentList.map((v) => v.name);
          }
          if (res.data.groupList && res.data.groupList.length > 0) {
            this.groupList = res.data.groupList;
            this.checkGroupList = this.groupList.map((v) => v.name);
          }
        }
      },
      searchDate() {
        if (this.tabsVal === 'name1') {
          this.querySaleManagerListModel1();
        } else if (this.tabsVal === 'name2') {
          this.querySaleManagerListModel2();
        }
      },
      async querySaleManagerListModel1() {
        $api.authorization.querySaleManagerListModel
          .GET({
            params: {
              identityType: 1,
              page: 1,
              rows: 500,
              userName: this.name
            },
          })
          .then((res) => {
            this.managerListData = res.data.rows;
            this.managerListData.map((i) => {
              this.managerRecords.map((j) => {
                if (parseInt(i.id) === j.id) {
                  this.$refs.managerListTable.setCheckboxRow(i, true);
                }
              });
            });
          });
      },
      querySaleManagerListModel2() {
        $api.authorization.querySaleManagerListModel
          .GET({
            params: {
              identityType: 0,
              page: 1,
              rows: 500,
              userName: this.name
            },
          })
          .then((res) => {
            this.salesmanListData = res.data.rows;
            this.salesmanListData.map((i) => {
              this.salesmanList.map((j) => {
                if (parseInt(i.id) === j.id) {
                  this.$refs.salesmanListTable.setCheckboxRow(i, true);
                }
              });
            });
          });
      },
      addShareData() {
        this.isShowAddShareData = true;
        this.tabsVal = "name1";
        if (this.managerList.length > 0) {
          this.managerRecords = [...this.managerList];
        }
        if (this.salesmanList.length > 0) {
          this.salesmanRecords = [...this.salesmanList];
        }
        if (this.departmentList.length > 0) {
          this.departmentListRecords = [...this.departmentList];
        }
        if (this.groupList.length > 0) {
          this.groupListRecords = [...this.groupList];
        }
        this.getAddData();
      },
      async getAddData() {
        this.querySaleManagerListModel1();
        this.querySaleManagerListModel2();
        let url = `listDepartment/-1`;
        let res = await $api.department.get(url);
        if (res.status === 1) {
          this.departmentListData = res.data;
          let arr = [];
          this.departmentList.forEach((v) => {
            let i = this.departmentListData.findIndex((item) => {
              return item.id === v.id;
            });
            arr.push(this.departmentListData[i]);
          });
          this.$refs.departmentListTable.setCheckboxRow(arr, true);
        }
        $api.authorization.groupListModel.GET().then((res) => {
          this.groupListData = res.data;
          let arr = [];
          this.groupList.forEach((v) => {
            let i = this.groupListData.findIndex((item) => {
              return item.id === v.id;
            });
            arr.push(this.groupListData[i]);
          });
          this.$refs.groupListTable.setCheckboxRow(arr, true);
        });
      },
      async submitShareData() {
        this.managerList = [...this.managerRecords];
        this.salesmanList = [...this.salesmanRecords];
        let departmentListRecords = this.$refs.departmentListTable.getCheckboxRecords();
        this.departmentList = [...departmentListRecords];
        let groupListRecords = this.$refs.groupListTable.getCheckboxRecords();
        this.groupList = [...groupListRecords];
        this.checkManagerList = [];
        this.managerRecords.forEach((v) => {
          this.checkManagerList.push(v.name);
          this.checkManagerList = [...new Set(this.checkManagerList)];
        });
        this.checkSalesmanList = [];
        this.salesmanRecords.forEach((v) => {
          this.checkSalesmanList.push(v.name);
          this.checkSalesmanList = [...new Set(this.checkSalesmanList)];
        });
        this.checkDepartmentList = [];
        departmentListRecords.forEach((v) => {
          this.checkDepartmentList.push(v.name);
          this.checkDepartmentList = [...new Set(this.checkDepartmentList)];
        });
        this.checkGroupList = [];
        groupListRecords.forEach((v) => {
          this.checkGroupList.push(v.name);
          this.checkGroupList = [...new Set(this.checkGroupList)];
        });

        let url = `saveSharing/${this.userId}`;
        let sharingVO = {
          departmentList: [],
          groupList: [],
          managerList: [],
          salesmanList: [],
        };
        this.checkManagerList.forEach((item) => {
          let findObj = this.managerList.find((v) => {
            return v.name === item;
          });
          sharingVO.managerList.push(findObj);
        });
        this.checkGroupList.forEach((item) => {
          let findObj = this.groupList.find((v) => {
            return v.name === item;
          });
          sharingVO.groupList.push(findObj);
        });
        this.checkDepartmentList.forEach((item) => {
          let findObj = this.departmentList.find((v) => {
            return v.name === item;
          });
          sharingVO.departmentList.push(findObj);
        });
        this.checkSalesmanList.forEach((item) => {
          let findObj = this.salesmanList.find((v) => {
            return v.name === item;
          });
          sharingVO.salesmanList.push(findObj);
        });

        let res = await $api.baseUserSign.post(url, sharingVO);
        if (res.status === 1) {
          this.$XModal.message({message: "修改成功！"});
          this.closeShareData();
          this.getShareList(this.curId);
        }
      },
      managerSelectAllEvent({checked, records}) {
        if (checked) {
          this.managerRecords = records;
        } else {
          this.managerRecords = [];
        }
      },
      managerSelectChangeEvent({checked, row}) {
        if (checked) {
          this.managerRecords.push(row);
        } else {
          let key = this.managerRecords.indexOf(row);
          this.managerRecords.splice(key, 1);
        }
      },
      salesmanSelectAllEvent({checked, records}) {
        if (checked) {
          this.salesmanRecords = records;
        } else {
          this.salesmanRecords = [];
        }
      },
      salesmanSelectChangeEvent({checked, row}) {
        if (checked) {
          this.salesmanRecords.push(row);
        } else {
          let key = this.salesmanRecords.indexOf(row);
          this.salesmanRecords.splice(key, 1);
        }
      },
    }
  }
</script>
<style>
  .authorization-user-handle a {
    margin: 0 10px;
    color: #000;
  }

  .permissions-main {
    height: 370px;
    width: 100%;
  }

  .permissions-con {
    width: 100%;
    box-sizing: border-box;
    padding: 20px;
    /*height: 280px;*/
    margin-bottom: 10px;
    overflow-y: scroll;
  }

  .permissions-main .add-btn-box {
    width: 100%;
  }

  .role-list {
    display: block;
    width: 100%;
    height: 24px;
    line-height: 24px;
    overflow: hidden;
    margin: 3px 0;
  }

  .permissions-con {
    position: relative;
  }

  .permissions-con dl {
    margin-bottom: 20px;
    width: 100%;
    position: relative;
    padding-left: 110px;
    min-height: 20px;
  }

  .permissions-con dt {
    width: 100px;
    float: left;
    text-align: right;
    padding-right: 20px;
    box-sizing: border-box;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
  }

  .topBtn {
    display: flex;
  }

  .topBtn .btn {
    margin-left: 20px;
    margin-top: 10px;
    width: 110px;
    height: 34px;
    background: #438DF3;
    border-radius: 4px;
  }

  .phoneInput .vxe-input--suffix {
    right: 0.5rem !important;
  }

  .phoneInput .vxe-input--extra-suffix {
    display: none;
  }

  .table-view {
    width: 325px;
    height: 490px;
    border: 1px solid #DFDFDF;
  }

  .table-title {
    display: flex;
    align-items: center;
    height: 57px;
    padding: 20px;
    box-sizing: border-box;
  }

  .blo {
    width: 4px;
    height: 16px;
    background: #1A8CFE;
  }

  .table-title span {
    margin-left: 11px;
    font-size: 15px;
    font-family: Microsoft YaHei, sans-serif;
    font-weight: 400;
    color: #333333;
  }

  .data-table {
    display: flex;
    align-items: center;
    gap: 20px;
  }
</style>